<template>
  <div class="result">
    <!-- <add-ut /> -->
    <ui-loading-circle :descText="'downloadingDot'" :applyBackground="true" v-if="!isLoaded"/>
    <result-menu :active="'preview'" :utid="utid"/>

    <div class="bridge-content" v-if="isLoaded && !isError">
      <h2><span>테스트 제목</span></h2>
      <h4>{{ utData.testName }}</h4>
      <h2><span>담당자 연락처</span></h2>
      <h4>{{utData.contact}}</h4>
      <h2><span>테스트 내용</span></h2>
      <p v-html="utData.contents"></p>

      <div class="question-cont" v-if="utData.surveyInfo.question.length > 0">
        <h2><span>문항</span></h2>

        <template v-for="(question, index) in utData.surveyInfo.question">
          <div v-bind:key="index">
            <h5 :class="{'mT100' : index !== 0}">
              <span>{{ index + 1 }}.</span>
              {{ question.subject }}
            </h5>

            <template v-for="(item, itemIndex) in question.items">
              <component
                v-bind:key="itemIndex"
                :is="'ui-' + question.itemType"
                :checkText="item"
                :checkLabel="question.itemType + index + 'Id' + itemIndex"
                :checkName="question.itemType + index + 'Name'"
                :radioText="item"
                :radioLabel="question.itemType + index + 'Id' + itemIndex"
                :radioName="question.itemType + index + 'Name'"
                :inputValue="itemIndex"
                :index="itemIndex"
                :parentIndex="index"
              />
            </template>

          </div>
        </template>
      </div>
      <div class="information-cont">
        <ul>
          <li>
            <ui-checkbox :value="isPrivacyAgree" :checkLabel="'privacy_checkbox'" :checkText="'개인정보 수집 및 이용 동의'" :contList="'information'" @input="onClickPrivacyAgree" />
            <button-item :btnText="'자세히 보기'" :btnClass="'information'" @click="onClickAgreement('privacy_checkbox')"/>
          </li>
          <li>
            <ui-checkbox :value="isThirdPartyAgree" :checkLabel="'third_checkbox'" :checkText="'제 3자 정보제공 동의'" :contList="'information'"  @input="onClickThirdPartyAgree" />
            <button-item :btnText="'자세히 보기'" :btnClass="'information'" @click="onClickAgreement('third_checkbox')"/>
          </li>
        </ul>
      </div>
      <h2><span>테스트 URL</span></h2>
      <h4>{{utData.url}}</h4>
    </div>
  </div>
</template>

<script>

import ButtonItem from '@/components/ui/button'
import UiCheck from '@/components/ui/UiCheck'
import UiRadio from '@/components/ui/UiRadio'
import ResultMenu from '@/components/result/ResultMenu'
import { getUt } from '@/api/ut'
import { create } from 'vue-modal-dialogs'

import BridgeInformationPop from '@/components/layerpop/BridgeInformationPop'

let infoLayer = create(BridgeInformationPop, 'type', 'terms')

export default {
  name: 'Dashboard',
  components: {
    ButtonItem,
    ResultMenu,
    'ui-radio': UiRadio,
    'ui-checkbox': UiCheck
  },
  props: [
    'utid'
  ],
  data () {
    return {
      isLoaded: false,
      isError: false,
      utData: null,
      isPrivacyAgree: false,
      isThirdPartyAgree: false
    }
  },
  mounted () {
    document.documentElement.scrollTo(0, 0)
  },
  created () {
    this.getData()
  },
  methods: {
    async onClickAgreement (type) {
      let terms = this.utData.terms1
      if (type === 'third_checkbox') {
        terms = this.utData.terms2
      }
      const confirmResult = await infoLayer(type, terms)
      if (confirmResult) {
        if (type === 'privacy_checkbox') {
          this.isPrivacyAgree = true
        }
        if (type === 'third_checkbox') {
          this.isThirdPartyAgree = true
        }

        document.querySelector('#' + type).setAttribute('checked', 'checked')
      }
    },
    onClickPrivacyAgree (value) {
      this.isPrivacyAgree = value
    },
    onClickThirdPartyAgree (value) {
      this.isThirdPartyAgree = value
    },
    getData () {
      this.isLoaded = false
      const params = {
        utid: this.utid
      }
      getUt(params).then(data => {
        this.isLoaded = true
        if (data.success) {
          this.utData = data.result

          if (this.utData.state === 'end') {
            this.isEnd = true
          }
        }
      }).catch(error => {
        this.isLoaded = true
        this.$store.commit('setErrorData', error)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.result {
  margin: 90px auto 0;
  padding-bottom: 160px;

  & > h1 {
    width: 990px;
    font-size: 20px;
    font-weight: 500;
    color: #2f2f2f;
    margin: 0 auto;

    & span {
      display: inline-block;
      width: 32px;
      height: 32px;
      vertical-align: top;
      border-radius: 5px;
      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(0, 0, 0, 0.06);
      background: #fff url('../../../assets/images/icon-page-back.svg') no-repeat center;
      margin-right: 30px;
      cursor: pointer;
      transition: 0.3s;

      &:hover {
        background: #f7f7f7 url('../../../assets/images/icon-page-back.svg') no-repeat center;
      }
    }

    & > button {
      display: inline-block;
      margin: 0px 40px 0 0;
      padding-bottom: 8px;
      color: #999;
      vertical-align: top;
      cursor: default;

      &.active {
        border-bottom: 3px solid #ec0047;
        color: #2f2f2f;
        cursor: pointer;
      }
    }
  }

  .bridge-content {
    width: 990px;
    height: auto;
    border-radius: 12px;
    box-shadow: 0 23px 15px -12px rgba(0, 0, 0, 0.10), 0 0 0 1px rgba(0, 0, 0, 0.10);
    background: #fff;
    padding: 60px 60px 70px;
    box-sizing: border-box;
    margin: 30px auto 0;

    h2 {
      font-size: 15px;
      font-weight: bold;
      color: #1990c2;
      padding-bottom: 8px;
      border-bottom: 3px solid #1990c2;
    }

    h4 {
      font-size: 20px;
      line-height: 1.6;
      color: #333;
      margin: 20px 0 80px;

      &:last-child {
        margin: 20px 0 0;
      }
    }

    h5 {
      font-size: 14px;
      line-height: 1.57;
      color: #444;
      font-weight: bold;
      margin: 50px 0 0 0;
    }

    p {
      font-size: 14px;
      line-height: 1.57;
      color: #444;
      margin-top: 20px;
      ::v-deep p {
        font-size: 14px;
        line-height: 1.57;
        color: #444;
      }
      ::v-deep img {
        max-width: 100%;
      }
      &.mT30 {
        margin-top: 30px;
      }
    }

    .visual-cont {
      width: 640px;
      height: 640px;
      background: #d8d8d8;
      margin: 40px auto 0;
    }

    .question-cont {
      margin-top: 120px;

      h5 {
        position: relative;
        font-size: 20px;
        line-height: 1.6;
        color: #333;
        font-weight: normal;
        padding-left: 30px;
        margin-bottom: 35px;

        &.mT100 {
          margin-top: 100px;
        }

        span {
          display: block;
          position: absolute;
          left: 0;
        }
      }
    }

    .information-cont {
      width: 100%;
      height: 155px;
      border-radius: 8px;
      border: solid 1px #ccc;
      background-color: #f7f7f7;
      margin: 50px 0 80px;
      padding: 20px 210px 0;
      box-sizing: border-box;

      ul {
        li {
          position: relative;
          padding-bottom: 5px;
        }
      }
    }
  }
}

@media all and (max-width: 990px) {
  .result {
      min-width: 768px;

      & > h1 {
          width: calc(100% - 40px);
      }
      .bridge-content {
          position: relative;
          width: calc(100% - 40px);
          height: auto;
          .information-cont {
            width: 100%;
            margin: 50px 0 80px;
            padding: 20px 100px 0;
            box-sizing: border-box;
          }
      }
  }
}
</style>
